import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Home from "./component/Home";
import AuthProvider from "./context/auth";
import { DayBoundaryProvider } from "./context/DayBoundaryContext";
import PrivateRoute from "./component/PrivateRoute";
import GroupAccessGuard from "./component/GroupAccessGuard";
import Welcome from "./component/Welcome";

import { memo, useEffect } from "react";
import TermsOfService from "./component/TermsOfService";
import PrivacyPolicy from "./component/PrivacyPolicy";
import GoalForm from "./forms/GoalForm";
import Profile from "./component/Profile";
import AdminSetting from "./component/AdminSetting";
import DDP from "./component/DDP";
import SupportPage from "./component/SupportPage";
import ContactConfirmationPage from "./component/ContactConfirmationPage";
import Music from "./component/Music";
import GroupingTest from "./component/GroupingTest";
import ContactRequests from "./component/ContactRequests";
import UsersList from "./component/UsersList";
import UsersListEx from "./component/UserListEx";

import UserVerification from "./component/UserVerification";
import AnnouncementList from "./component/AnnouncementList";
import VideoPage from "./component/VideoPage";
import GroupManagement from "./component/GroupManagement";
import MapComponent from "./component/MapComponent";
import HokkaidoMapComponent from "./component/HokkaidoMapComponent";
import Group from "./component/Group";
import GroupMemberCustom from "./component/GroupMemberCustom";
import GroupManagementEx from "./component/GroupManagementEx";
import NotVerified from "./component/NotVerified";
import ChannelLoader from "./component/ChannelLoader";
import GroupsList from "./component/GroupsList";
import ChannelLoaderEx from "./component/ChannelLoaderEx";
import PaymentSuccess from "./component/PaymentSuccess";
import PaymentCancel from "./component/PaymentCancel";
import TokenRegistration from "./component/TokenRegistration";
import TokenVerificationPage from "./component/TokenVerificationPage";
import VerifiedUserCount from "./component/VerifiedUserCount";
import AddBankTransferPayments from "./component/AddBankTransferPayments";
import PostManagement from "./component/PostManagement";
import VideoManagement from "./component/VideoManagement";
import TokenViewer from "./component/TokenViewer";
import ImportDDPComponent from "./component/ImportDDPComponent";
import ReviewDDP from "./component/ReviewDDP";
import TokenInfoPage from "./component/TokenInfoPage";
import UserStatsPage from "./component/UserStatsPage";
import PrefectureChatPage from "./component/PrefectureChatPage";
import RegionChatPage from "./component/RegionChatPage";
import SpecificCategoryRequests from "./component/SpecificCategoryRequests";
import UpdateUserPrices from "./component/UpdateUsersPrice";
import YaeNoInoriForm from "./component/YaeNoInoriForm";
import PaymentInfo from "./component/PaymentInfo";
import FilterGroupActivityUsers from "./component/FilterGroupActivityUsers";
import UidGroupChecker from "./component/UidGroupChecker";
import DataUploader from "./component/DataUploader";
import Groups2025H from "./component/Groups2025H";
import ReiNoInoriCount from "./component/ReiNoInoriCount";
import EmailLookupComponent from "./component/EmailLookupComponent";
import MailChecker from "./component/MailChecker";
import PrefectureCountList from "./component/PrefectureCountList";
import Rate from "./component/Rate";
import TieredPricing from "./component/TieredPricing";
import GroupReportsAdmin from "./component/GroupReportsAdmin";
import YaeNoInoriPage from "./component/YaeNoInoriPage";
import LinkCommentList from "./component/LinkCommentList";
import ChatSelectorPage from "./component/ChatSelectorPage";
import PaymentContainer from "./component/PaymentContainer";
import PaymentContainer2025Late from "./component/PaymentContainer2025Late";
import PaymentPhaseAdmin from "./component/PaymentPhaseAdmin";
import YaeInvitationPage from "./component/YaeInvitationPage";
import CountReiNoInoriDocs from "./component/CountReiNoInoriDocs";
import BankTransferList from "./component/BankTransferList";
import PublicRouteLayout from "./component/PublicRouteLayout";
import YaeNoInoriAdminForm from "./component/YaeNoInoriAdminForm";
import YaeNoInoriEditor from "./component/YaeNoInoriEditor";
import DdpForm from "./component/DdpForm";
import DDPSetting from "./component/DDPSetting";
import GroupingPage from "./component/GroupingPage";
import FilterGroupActivityUsers2025SecondHalf from "./component/FilterGroupActivityUsers2025SecondHalf";
import Grouping2025SecondHalf from "./component/Grouping2025SecondHalf";
import Groups2025HL from "./component/Groups2025HL";
import YaeBook from "./component/YaeBook";
import RitesOfLightLP from "./component/RitesOfLightLP";
import MMChatStatsPage from "./component/MMChatStatsPage";
import AnswerProgressOnDemand from "./component/AnswerProgressOnDemand";
import MastermindHero from "./component/MastermindHero";
import Private from "./component/Private";
import AdminRoute from "./component/AdminRoute";
import TopPage from "./component/TopPage";
import AdminHome from "./component/AdminHome";
import AdminTopPagePreview from "./component/AdminTopPagePreview";
import VideoAdminPage from "./component/VideoAdminPage";
import UserAdminPage from "./component/UserAdminPage";
import DailyPostsAdminPage from "./component/DailyPostsAdminPage";
import AnnouncementAdminPage from "./component/AnnouncementAdminPage";
import MusicAdminPage from "./component/MusicAdminPage";
import PaymentPhaseAdmin2026 from "./component/PaymentPhaseAdmin2026";
import Group2025LHN from "./component/Group2025LHN";
import Group2026 from "./component/Group2026";
import CommunityChatPage from "./component/CommunityChatPage";
import ContactSupportCenter from "./component/ContactSupportCenter";
import YaeChikaiPage from "./component/YaeChikaiPage";
import MyPage from "./component/MyPage";
import MyProfile from "./component/MyProfile";
import MM2026DialogAdmin from "./component/MM2026DialogAdmin";
import PromoBannerAdmin from "./component/PromoBannerAdmin";
import GroupActivity2026DialogAdmin from "./component/GroupActivity2026DialogAdmin";
import GroupActivity2026List from "./component/GroupActivity2026List";
import AdminGroupAllocation2026 from "./component/AdminGroupAllocation2026";
import AdminGroupAllocation2026Watch from "./component/AdminGroupAllocation2026Watch";
import AdminGroupActivity2026BulkJoin from "./component/AdminGroupActivity2026BulkJoin";
import PaymentStatus2026 from "./component/PaymentStatus2026";
import MM2026JoinContent from "./component/MM2026JoinContent";
import MusicPlaybackIssueMonitor from "./component/MusicPlaybackIssueMonitor";
import CommunityFeed from "./component/CommunityFeed";
import UIVisibilityAdmin from "./component/UIVisibilityAdmin";
import AdminMusicMonitoring from "./component/AdminMusicMonitoring";
import AdminMusicListeningControl from "./component/AdminMusicListeningControl";
import CurrentBuildAdmin from "./component/CurrentBuildAdmin";
import FirestoreReadCheck from "./component/FirestoreReadCheck";
import FirestoreRulesProbe from "./component/FirestoreRulesProbe";
import AdminUserAttributes from "./component/AdminUserAttributes";
import AdminPrefectureCityMismatch from "./component/AdminPrefectureCityMismatch";
import AdminGuides2026 from "./component/AdminGuides2026";
import AdminGroupChats2026Stats from "./component/AdminGroupChats2026Stats";
import AdminGroupChat2026Migrate from "./component/AdminGroupChat2026Migrate";
import GroupReportsAdmin2026 from "./component/GroupReportsAdmin2026";

import AdminDayBoundary from "./component/AdminDayBoundary";
import AdminOtohikari from "./component/AdminOtohikari";
import OtohikariTest from "./component/OtohikariTest";
import AdminSekaimuraTokenRegister from "./component/AdminSekaimuraTokenRegister";
import AdminCommunityFeedVisibility from "./component/AdminCommunityFeedVisibility";
import AdminMusicPlaybackErrors from "./component/AdminMusicPlaybackErrors";
import RibbonBubbleAdmin from "./component/RibbonBubbleAdmin";
import AdminCotozute from "./component/AdminCotozute";
import CouponAdminPage from "./component/CouponAdminPage";
import PortalPage from "./component/PortalPage";
import EventsPage from "./component/EventsPage";
import VillageMapPage from "./component/VillageMapPage";
import VillageMapLeaflet from "./component/VillageMapLeaflet";
import { StreamChatProvider } from "./context/StreamChatProvider";

function App() {
  // useAppLifecycle();
  // useAuthListener(); // デバイス登録
  // useUpdateDeviceStatusOnVisibilityChange(); // VisibilityChange関数

  // useEffect(() => {
  //   requestForToken();
  // }, []);

  return (
    <>
      <DayBoundaryProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/riteoflight" element={<RitesOfLightLP />} />

            <Route path="/welcome" element={<Welcome />} />
            <Route path="/" element={<Welcome />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/notverified" element={<NotVerified />} />
            <Route path="/supportpage" element={<SupportPage />} />
            <Route path="/termsofservice" element={<TermsOfService />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/rate" element={<Rate />} />

            {/* マスターマインド2026 */}
            <Route element={<Private />}>
              <Route path="/portal" element={<PortalPage />} />
              <Route element={<AdminRoute />}>
                <Route path="/events" element={<EventsPage />} />
                <Route path="/village-map" element={<VillageMapPage />} />
                <Route path="/village-map-free" element={<VillageMapLeaflet />} />
              </Route>
              <Route path="/home" element={<TopPage />} />
              {/* 管理者メニュー */}
              <Route path="/admin" element={<AdminHome />} />
              <Route path="/admin/toppage-preview" element={<AdminTopPagePreview />} />
              <Route path="/admin/videos" element={<VideoAdminPage />} />
              <Route path="/admin/users" element={<UserAdminPage />} />
              <Route path="/admin/music" element={<MusicAdminPage />} />
              <Route path="/admin/daily-posts" element={<DailyPostsAdminPage />} />
              <Route path="/admin/importantAnnouncement" element={<AnnouncementAdminPage />} />
              <Route path="/admin/paymentAdmin2026" element={<PaymentPhaseAdmin2026 />} />
              <Route path="/admin/bankTransferList" element={<BankTransferList />} />
              <Route path="/admin/mm2026-dialog" element={<MM2026DialogAdmin />} />
              <Route path="/admin/promo-banner" element={<PromoBannerAdmin />} />
              <Route path="/admin/group-activity-2026" element={<GroupActivity2026DialogAdmin />} />
              <Route path="/admin/group-activity-2026-list" element={<GroupActivity2026List />} />
              <Route path="/admin/group-allocation-2026" element={<AdminGroupAllocation2026 />} />
              <Route path="/admin/group-allocation-2026-watch" element={<AdminGroupAllocation2026Watch />} />
              <Route path="/admin/group-activity-2026-bulk-join" element={<AdminGroupActivity2026BulkJoin />} />
              <Route path="/admin/paymentStatus2026" element={<PaymentStatus2026 />} />
              <Route path="/admin/music-playback-logs" element={<MusicPlaybackIssueMonitor />} />
              <Route path="/admin/ui-visibility" element={<UIVisibilityAdmin />} />
              <Route path="/admin/music-monitoring" element={<AdminMusicMonitoring />} />
              <Route path="/admin/grant-by-uid" element={<AddBankTransferPayments />} />
              <Route path="/admin/music-listening-control" element={<AdminMusicListeningControl />} />
              <Route path="/admin/current-build" element={<CurrentBuildAdmin />} />
              <Route path="/admin/firebaseReacCheck" element={<FirestoreReadCheck />} />
              <Route path="/admin/fireStoreRulesProbe" element={<FirestoreRulesProbe />} />
              <Route path="/admin/user-attributes" element={<AdminUserAttributes />} />
              <Route path="/admin/prefecture-city-mismatch" element={<AdminPrefectureCityMismatch />} />
              <Route path="/admin/guides-2026" element={<AdminGuides2026 />} />
              <Route path="/admin/group-chats-2026-stats" element={<AdminGroupChats2026Stats />} />
              <Route path="/admin/group-chat-2026-migrate" element={<AdminGroupChat2026Migrate />} />
              <Route path="/admin/group-reports-2026" element={<GroupReportsAdmin2026 />} />
              <Route path="/admin/sekaimura-token-register" element={<AdminSekaimuraTokenRegister />} />
              <Route path="/admin/community-feed-visibility" element={<AdminCommunityFeedVisibility />}/>
              <Route path="/admin/music-playback-errors" element={<AdminMusicPlaybackErrors />} />
              <Route path="/admin/ribbon-bubble" element={<RibbonBubbleAdmin />} />
              <Route path="/admin/day-boundary" element={<AdminDayBoundary />} />
              <Route path="/admin/otohikari" element={<AdminOtohikari />} />
              <Route path="/otohikari-test" element={<OtohikariTest />} />
              <Route path="/admin/cotozute" element={<AdminCotozute />} />
              <Route path="/admin/coupon" element={<CouponAdminPage />} />
              

              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route
                path="/groups2025hln/:id"
                element={
                  <GroupAccessGuard period="2025hln">
                    <Group2025LHN />
                  </GroupAccessGuard>
                }
              />
              <Route
                path="/groups2026/:id"
                element={
                  <GroupAccessGuard period="2026">
                    <Group2026 />
                  </GroupAccessGuard>
                }
              />
              <Route element={<StreamChatProvider />}>
                <Route path="communication" element={<CommunityChatPage />} />
              </Route>
              <Route path="contactPage" element={<ContactSupportCenter />} />
              <Route path="yaeChikaiPage" element={<YaeChikaiPage />} />
              <Route path="/yaeChikaiBookPage" element={<YaeBook />} />
              <Route path="/mypage" element={<MyProfile />} />
              <Route path="/mm2026join-content" element={<MM2026JoinContent />} />
              <Route path="/communityFeed" element={<CommunityFeed />} />

            </Route>

            <Route element={<PublicRouteLayout />}>
              {/* <Route path="/yaenoinori" element={<YaeNoInoriPage />} /> */}
              <Route path="/yae-chikai" element={<YaeNoInoriPage />} />
            </Route>

            {/* マスターマインド2024,2025 */}
            <Route element={<PrivateRoute />}>
              {/* <Route path="/home" element={<Home />} /> */}
              <Route path="/profile" element={<Profile />} />
              <Route path="/adminSetting" element={<AdminSetting />} />
              <Route path="/ddp" element={<DDP />} />
              <Route path="/videos" element={<VideoPage />} />
              <Route path="/verifing" element={<TokenVerificationPage />} />
              <Route path="/announcements" element={<AnnouncementList />} />
              <Route path="/support" element={<SupportPage />} />
              <Route
                path="/group/:id"
                element={
                  <GroupAccessGuard period="2024">
                    <Group />
                  </GroupAccessGuard>
                }
              />
              <Route
                path="/groups2025/:id"
                element={
                  <GroupAccessGuard period="2025h">
                    <Groups2025H />
                  </GroupAccessGuard>
                }
              />
              <Route
                path="/groups2025hl/:id"
                element={
                  <GroupAccessGuard period="2025hl">
                    <Groups2025HL />
                  </GroupAccessGuard>
                }
              />
              <Route path="/reviewDDP" element={<ReviewDDP />} />
              <Route path="/setDDP" element={<DDPSetting />} />
              <Route path="/yae" element={<YaeInvitationPage />} />
              <Route path="/yae-chikai-book" element={<YaeBook />} />

              <Route
                path="/countReinoInori"
                element={<CountReiNoInoriDocs />}
              />

              <Route path="/admin/music" element={<Music />} />
              <Route path="/admin/usersMap" element={<MapComponent />} />
              <Route
                path="/admin/usersMapHokkaido"
                element={<HokkaidoMapComponent />}
              />
              <Route path="/admin/grouping" element={<GroupManagementEx />} />
              <Route path="/admin/groups" element={<GroupManagementEx />} />
              <Route path="/admin/support" element={<ContactRequests />} />
              <Route path="/admin/checkToken" element={<TokenViewer />} />
              <Route path="/admin/userlist" element={<UsersListEx />} />
              <Route
                path="/admin/addBankTransferPayment"
                element={<AddBankTransferPayments />}
                />
              <Route
                path="/admin/tokenRegistration"
                element={<TokenRegistration />}
                />
              <Route
                path="/admin/postManagement"
                element={<PostManagement />}
                />
              <Route
                path="/admin/videoManagement"
                element={<VideoManagement />}
                />
              <Route path="/admin/paymentInfo" element={<PaymentInfo />} />

              <Route
                path="/admin/paymentPhase"
                element={<PaymentPhaseAdmin />}
                />
                {/* <Route
                  path="/admin/groupMemberCustom"
                  element={<GroupMemberCustom />}
                /> */}
                {/* <Route path="/admin/groupList" element={<GroupsList />} /> */}
                {/* <Route path="/admin/groupSearch" element={<ChannelLoader />} />
                <Route
                  path="/admin/groupSearchEx"
                  element={<ChannelLoaderEx />}
                /> */}
              {/* <Route path="/admin/yaenoinori" element={<YaeNoInoriForm />} /> */}
              {/* <Route path="/admin/paymentInfo" element={<PaymentInfo />} /> */}
              {/* <Route path="/admin/tokenInfoPage" element={<TokenInfoPage />} /> */}
              {/* <Route path="/admin/userStatusPage" element={<UserStatsPage />} /> */}
              {/* <Route path="/admin/updateUsersPrice" element={<UpdateUserPrices />} />  */}

              {/* <Route path="/admin/SpecificCategoryRequests" element={<SpecificCategoryRequests />} /> */}

              {/* 2025halfグループわけで使用 */}
              <Route
                path="/admin/FilterGroupActivityUsers"
                element={<FilterGroupActivityUsers />}
              />
              {/* 2025halfSecondグループわけで使用 */}
              <Route
                path="/admin/FilterGroupActivityUsers2025"
                element={<FilterGroupActivityUsers2025SecondHalf />}
              />

              {/* 3期のグループわけ作業で使用 */}
              <Route
                path="/admin/grouping2025SecondHalf"
                element={<Grouping2025SecondHalf />}
              />
              <Route
                path="/admin/uidGroupChecker"
                element={<UidGroupChecker />}
              />

              {/* 3期グループ分けで仕様 */}
              <Route path="/admin/groupingPage" element={<GroupingPage />} />
              <Route path="/admin/groupingTest" element={<GroupingTest />} />

              {/* 2025令和のミトキデータ投入で使用 */}
              {/* <Route path="/admin/EmailLookupComponent" element={<EmailLookupComponent />} />  */}
              {/* ミトキのデータ振り分け */}
              {/* <Route
                path="/admin/ReiNoInoriCount"
                element={<ReiNoInoriCount />}
              /> */}
              {/* メールアドレスからReiNoInoriのデータを追う */}
              {/* <Route path="/admin/MailChecker" element={<MailChecker />} /> */}
              {/* 都道府県別ReiNoInoriのデータを追う */}
              <Route
                path="/admin/PrefectureCountList"
                element={<PrefectureCountList />}
              />

              <Route path="/admin/TieredPricing" element={<TieredPricing />} />

              {/* グループ通報 */}
              <Route
                path="/admin/GroupReportsAdmin"
                element={<GroupReportsAdmin />}
              />

              <Route
                path="/admin/LinkCommentList"
                element={<LinkCommentList />}
              />

              <Route
                path="/admin/yaeNoInoriAdminForm"
                element={<YaeNoInoriAdminForm />}
              />

              <Route path="/countChatMessages" element={<MMChatStatsPage />} />

              <Route
                path="/admin/yaeNoInoriEditor"
                element={<YaeNoInoriEditor />}
              />

              {/* 2025後期支払いページ */}
              <Route path="/pay" element={<PaymentContainer2025Late />} />

              <Route path="/bankTransferList" element={<BankTransferList />} />

              {/* <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} /> */}

              <Route element={<StreamChatProvider />}>
                <Route path="/prefecture-chat" element={<PrefectureChatPage />} />
                <Route path="/region-chat" element={<RegionChatPage />} />
                <Route
                  path="/world-chat/:prefName"
                  element={<RegionChatPage />}
                />
                <Route path="/ChatSelectorPage" element={<ChatSelectorPage />} />
              </Route>

              {/* <Route path="/admin/userlist" element={<UsersList />} /> */}
              <Route
                path="/admin/verification"
                element={<UserVerification />}
              />
              <Route
                path="/contact-confirmation"
                element={<ContactConfirmationPage />}
              />
              <Route
                path="/yaeChikaiOnDemand"
                element={<AnswerProgressOnDemand />}
              />

              <Route path="/goal" element={<GoalForm />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      </DayBoundaryProvider>
    </>
  );
}

export default memo(App);
